import { useRef } from "react";

/**
 * True when `signature` stayed identical across the last `threshold` settled polls.
 * `cycleMarker` must advance once per settled fetch — pass React Query's `dataUpdatedAt`.
 */
export const useLiveDataFrozen = (
  enabled: boolean,
  resetKey: string,
  cycleMarker: number,
  signature: string | undefined,
  threshold: number,
): boolean => {
  const ref = useRef({ resetKey, cycleMarker, signature, unchanged: 0 });

  if (!enabled || ref.current.resetKey !== resetKey) {
    ref.current = { resetKey, cycleMarker, signature, unchanged: 0 };
    return false;
  }
  if (cycleMarker !== ref.current.cycleMarker) {
    ref.current.unchanged = signature === ref.current.signature ? ref.current.unchanged + 1 : 0;
    ref.current.signature = signature;
    ref.current.cycleMarker = cycleMarker;
  }
  return ref.current.unchanged >= threshold;
};
